

/* global google:false */
/* global slick:false */
/* global PhotoSwipe:false */
/* global PhotoSwipeUI_Default:false */

function resizeImages() {

	var firstSlideshow = $( ".first-slideshow" );
	if (firstSlideshow.length > 0) {
		if (window.innerWidth < window.innerHeight) {
			firstSlideshow.addClass("fsh-fix").removeClass("fsw-fix");
		} else {
			firstSlideshow.addClass("fsw-fix").removeClass("fsh-fix");
		}
	}
}

function scrolledWindow() {

	var body = $("body");

	var scroll = $(window).scrollTop();

	if (scroll >= 150) {
		body.addClass("scrolled");
	} else {
		body.removeClass("scrolled");
	}

	var scrollTop = $(".scroll-top");

	if (scrollTop.length > 0 ) {
		var wrapperFooter = $("#wrapper-footer").offset().top;
		if (scroll >= wrapperFooter ) {
			scrollTop.addClass("d-lg-block");
		} else {
			scrollTop.removeClass("d-lg-block");
		}
	}

}


$( document ).ready( function() {

	"use strict";

	var supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;

	scrolledWindow();

	resizeImages();

	// reSlick();

	var readMoreToggle = $(".read-more-toggle");
	if (readMoreToggle.length > 0) {
		readMoreToggle.each(function() {
			$(this).readMoreToggler();
		});
	}

	$("#dismiss, .overlay").on("click", function () {
		$("#sidebar").addClass("translate-x-minus-100");
		$(".overlay").addClass("d-none");
		$("body").removeClass("overflow-y-hidden");
	});

	$("#sidebarCollapse").on("click", function () {
		$("body").addClass("overflow-y-hidden");
		$("#sidebar").removeClass("translate-x-minus-100");
		$(".overlay").removeClass("d-none");
	});

	/**
	 *  Scroll To Content Button
	 *
	 * @type {jQuery.fn.init|jQuery|HTMLElement}
	 */
	var scrollDown = $(".scroll-down");
	var pageWrapper = $("#page-wrapper");
	if (scrollDown.length > 0 && pageWrapper.length > 0) {
		scrollDown.on("click", function(e) {
			e.preventDefault();
			// var offset = $("#wrapper-navbar").height();
			var offset = 0;

			$("html, body").animate({
				scrollTop: pageWrapper.offset().top - offset
			}, 500);
		});
	}

	/**
	 * Scroll To Top Button
	 *
	 * @type {jQuery.fn.init|jQuery|HTMLElement}
	 */
	var scrollTop = $(".scroll-top");

	if (scrollTop.length > 0) {
		scrollTop.on("click", function(e) {
			e.preventDefault();

			$("html, body").animate({
				scrollTop: $("body").offset().top
			}, 500);
		});
	}

	/**
	 * Webhotelier Form
	 */
	var $webhotelierForm = $("#webhotelier-form");
	if ($webhotelierForm.length > 0 ) {
		var elWebhotelierForm = $webhotelierForm;
		elWebhotelierForm.webhotelierForm(elWebhotelierForm.data("json"));
	}

	/**
	 * Parallax Backgrounds
	 */
	var parallaxElements = $("*[data-parallax-background-image-url]");
	if (parallaxElements.length > 0) {
		parallaxElements.each(function() {

			var parallaxElement = $(this);
			var parallaxImageUrl = parallaxElement.attr("data-parallax-background-image-url");

			if (parallaxImageUrl) {
				parallaxElement.css("background-image", "url(" + parallaxImageUrl +")");
			}

		});
	}

	/**
	 * Backgrounds Images
	 */
	var bgImageElements = $("*[data-bg-image-url]");
	if (bgImageElements.length > 0) {
		bgImageElements.each(function() {

			var bgImageElement = $(this);
			var bgImageElementeUrl = bgImageElement.attr("data-bg-image-url");

			if (bgImageElementeUrl) {
				bgImageElement.css("background-image", "url(" + bgImageElementeUrl +")");
			}

		});
	}

	var hoverBgImageItem = $("*[data-hover-bg-image]");
	if (hoverBgImageItem.length > 0 && ! supportsTouch) {
		hoverBgImageItem.each(function() {
			hoverBgImageItem.on({
				mouseenter: function() {
					$(this).addClass("active").find(".card-img").attr("src", $(this).attr("data-hover-bg-image"));
				},
				mouseleave: function() {
					$(this).removeClass("active").find(".card-img").attr("src", $(this).attr("data-bg-image"));
				}
			});
		});
	}

	/**
	 * Posts Slider
	 */
	var postsSlider = $("*[data-cards-slider]");
	if (postsSlider.length > 0) {
		postsSlider.each(function() {

			var slickWrapper = $(this);
			var slickElement = $(this).find(".cards-wrapper");
			var postsSliderSettings = {
				prevArrow: slickWrapper.find(".card-prev"),
				nextArrow: slickWrapper.find(".card-next"),
				// fade: true,
				mobileFirst: true,
				lazyLoad: "ondemand",
				autoplay: false,
				infinite: true,
				slidesToShow: ( slickElement.hasClass("home-any-cards-wrapper") ) ? 1 : 3,
				slidesToScroll: ( slickElement.hasClass("home-any-cards-wrapper") ) ? 1 : 3,
				// centerMode: false,
				// centerPadding: "50px",
				arrows: slickWrapper.hasClass("home-rooms") ? slickElement.find('.card').length > 3 : slickElement.find('.card').length > 1,
				// dots: ( slickWrapper.hasClass("home-rooms") && window.innerWidth < 768 ),
				dots: true,
				// dotsClass: slickWrapper.hasClass("home-rooms") || slickWrapper.hasClass("home-any") ? "slick-dots d-flex d-lg-none" : "slick-dots d-none",
				dotsClass: slickWrapper.hasClass("home-any") ? "slick-dots d-block d-lg-none" : "slick-dots d-none",

				// responsive: [
				// {
				// breakpoint: 768,
				// settings: {
				// slidesToShow: 3,
				// slidesToScroll: 3
				// }
				// },
				// {
				//     breakpoint: 768,
				//     settings:
				//         ( slickWrapper.hasClass("home-rooms") ) ? '' : 'unslick'
				// }
				// ]
			};

			var postsSliderSettingsMobile = {
				prevArrow: slickWrapper.find(".card-prev"),
				nextArrow: slickWrapper.find(".card-next"),
				mobileFirst: true,
				lazyLoad: "ondemand",
				autoplay: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				dotsClass: "slick-dots d-block d-lg-none"
			};

			if ( slickWrapper.hasClass("home-rooms") && window.innerWidth < 960 ) {
				slickElement.slick(postsSliderSettingsMobile);
			} else {
				slickElement.slick(postsSliderSettings);
			}

		});
	}

	/**
	 * Slick Slider
	 */
	var slickSlider = $("*[data-slick-slider]");
	if (slickSlider.length > 0) {
		slickSlider.each(function() {

			var slickWrapper = $(this);
			var slickElement = $(this).find(".slick-wrapper");

			var slickSliderSettings = {
				fade: false,
				mobileFirst: true,
				lazyLoad: "ondemand",
				autoplay: !!( slickElement.hasClass("footer-links-wrapper") ),
				adaptiveHeight: false,
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 2,
				// centerMode: true,
				// centerPadding: "50px",
				arrows: false,
				dots: true,
				dotsClass: slickWrapper.hasClass("footer-links-wrapper") ? "slick-dots" : "",
				appendDots: slickWrapper,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4,
							arrows: slickWrapper.find(".footer-link").length > 1,
							prevArrow: slickWrapper.find(".arrow-prev"),
							nextArrow: slickWrapper.find(".arrow-next"),
							dots: false,
						}
					}
				]
			};

			slickElement.slick(slickSliderSettings);

		});

	}

	/**
	 * First Slideshow
	 */
	var $firstSlideshow = $("*[data-first-slideshow]");
	if ($firstSlideshow.length > 0) {
		$firstSlideshow.flickity({
			contain: true,
			autoPlay: 5000,
			cellSelector: ".slideshow-cell",
			accessibility: true,
			prevNextButtons: false,
			pageDots: $firstSlideshow.find(".slideshow-cell").length > 1,
			setGallerySize: false,
			imagesLoaded: true,
			lazyLoad: true,
			draggable: ">1",
			wrapAround: true
		});
	}

	/**
	 * Accommodation Filtering
	 */
	var filters = $(".filters");
	if (filters.length > 0) {

		var listingWrapper = $(".listing-wrapper");
		listingWrapper.imagesLoaded( function() {
			listingWrapper.isotope({
				itemSelector: "article",
			});
		});

		filters.on("click", "a", function() {

			var filterValue = $(this).attr("data-filter");

			listingWrapper.isotope({
				filter: filterValue,
			});

			if (listingWrapper.hasClass('evenodd-listing')) {
				listingWrapper.find('.order-lg-last').removeClass('order-lg-last');
				listingWrapper.find('.align-items-lg-end').removeClass('align-items-lg-end');
				listingWrapper.find('.text-lg-right').removeClass('text-lg-right');
				listingWrapper.find(filterValue + ':visible:odd .col-lg-6:first-child').addClass('order-lg-last');
				listingWrapper.find(filterValue + ':visible:odd .col-lg-6:last-child').addClass('align-items-lg-end');
				listingWrapper.find(filterValue + ':visible:odd .col-lg-6:last-child').addClass('text-lg-right');
			}

			setTimeout(function(){
				let items = document.querySelectorAll('.listing-wrapper .room:not([style*="display: none"])');
				for (let i=0; i<items.length; i++) {
					if ( i % 2 != 0 ) {
						items[i].querySelector('.image-wrapper').classList.add('order-lg-last');

					}
					else {
						items[i].querySelector('.image-wrapper').classList.remove('order-lg-last');
					}
				}
			}, 300);

		});
	}

	/**
	 * Masonry Gallery
	 */
	var gallery = $("#masonry-gallery");
	if (gallery.length > 0) {
		gallery.imagesLoaded( function() {
			// init Isotope after all images have loaded
			gallery.isotope({
				itemSelector: ".gallery-item",
				percentPosition: true,

				// layout mode options
				masonry: {
					gutter: ".gallery-gutter-sizer",
					columnWidth: ".gallery-item-sizer"
				}

			});
		});

		/**
		 * Filter items on button click
		 */
		$("#masonry-gallery-filters li").on("click", "a", function() {
			gallery.isotope({
				filter: $(this).attr("data-filter")
			});
		});

		/**
		 * Lightbox
		 */
		gallery.photoswipeLightbox(gallery.data("photoswipe-options"));
	}

	/**
	 * Google Map
	 */
	var $map = $(".map");
	if ($map.length > 0) {
		var elMap = $map;

		elMap.googleMap(elMap.data("json"));

	}

});

$(function() {

	"use strict";

	$(window).resize(function() {

		// reSlick();

	});

	$(window).on('resize orientationchange', function() {

		var slickSlider = $('.slick-wrapper');

		// without this check, all kinds of weird errors happen, and the slider doesn't really work
		if ( ! slickSlider.hasClass('slick-initialized') ) {

			slickSlider.slick();

		}

	});

	$(window).scroll(function() {

		scrolledWindow();

		// showScrollToTop();

	});

});

(function($) {

	"use strict";

	/**
	 * Webhotelier Form Functon
	 *
	 * @param options
	 */
	$.fn.webhotelierForm = function(options) {
		var el = $(this);

		var settings = $.extend({
			// "split_dates": $(this).data("split_dates"),
			// "icon_dates": $(this).data("icon_date"),
		}, options);

		var checkinDateSplit = el.find("#checkin-date-split");

		function getField(id) {
			var el = $("#" + id + "-picker");
			return el.length ? el : null;
		}

		function fillSplitDates(id) {
			var el = getField(id);
			if (el !== null) {
				var date = el.datepicker("getDate");
				el.parent().find(".day").text(date.getDate());
				el.parent().find(".month").text(date.toLocaleString(document.documentElement.lang,{month: "short"}));
				el.parent().find(".year").text(date.getFullYear());
			}
		}

		function pickerSetup(id, date) {
			var el = getField(id);

			if (el !== null) {
				var checkin = (id === "checkin");

				el.datepicker({
					altField: el.get(0).form[id],
					altFormat: "yy-mm-dd",
					dateFormat: "d M yy",
					onSelect: function () {
						if (checkin && getField("checkout") !== null) {
							var constraint = new Date(el.datepicker("getDate"));
							constraint.setDate(constraint.getDate() + 1);
							getField("checkout").datepicker("option", "minDate", constraint);
						}
						if ( settings.split_dates ) {
							fillSplitDates(id);
						}
					},
					numberOfMonths: 2,
					mandatory: true,
					firstDay: 1,
					minDate: checkin ? 0 : 1,
					maxDate: "+2y",
					showOn: settings.icon_date ? "button" : "focus",
					buttonImage: settings.icon_date ? settings.icon_date : "",
					buttonImageOnly: settings.icon_date ? "true" : "false",
					buttonText: "Select date"
				});
				el.datepicker("setDate", date);

				if ( checkinDateSplit.length > 0 ) {
					fillSplitDates(id);
				}
			}
		}

		pickerSetup("checkin", "+0");
		pickerSetup("checkout", "+1");

		$("#checkin-date-split, #checkout-date-split").on("click", function() {
			$( this ).parent().find("input").datepicker( "show" );
		});

	};

	/**
	 * Google Map Function
	 */
	$.fn.googleMap = function(options) {
		var el = $(this);

		var settings = $.extend({
			"lat": "37.979561",
			"lng": "23.728487",
			"zoom": 13,
			"styles": "",
			"places_categories": false,
			"locations": [{
				lat: -33.890542,
				lng: 151.274856,
				address: "",
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: "",
				image_alt: "",
				info_title: "",
				info_text: "",
				info_btn: "",
				info_btn_url: "",
				info_btn_target: "",
			}],
		}, options);

		var markers = [];
		var bounds = new google.maps.LatLngBounds();
		var directionsDisplayOptions = {
			suppressMarkers: true
		};
		var directionsService = new google.maps.DirectionsService;
		var directionsDisplay = new google.maps.DirectionsRenderer;
		directionsDisplay.setOptions( directionsDisplayOptions );

		// var offsetHeight = $("nav.navbar").position();
		var offsetHeight = $("nav.navbar").height() * 2;

		var map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : "",
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {

			var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			var infoButtonString = "";
			var infoImageUrl = "";
			var markerInfowindow = false;
			var icon = false;

			if (attr.info_btn_url) {
				infoButtonString = "<p><a href=\"" + attr.info_btn_url + "\" target=\"" + attr.info_btn_target + "\">" + attr.info_btn + "</a></p>";
			}

			if (attr.image_src) {
				infoImageUrl = "<div class=\"side-gmap\"><img src=\"" + attr.image_src + "\" alt=\"" + attr.image_alt + "\" /></div>";
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					anchor: new google.maps.Point(20, 80),
					scaledSize: new google.maps.Size(40, 80),
				};
			}

			if (attr.info_text || attr.info_title) {
				var contentString =
					"<div class=\"map-infowindow\">" +
					infoImageUrl +
					"<div class=\"main-gmap\">" +
					"<h3 class=\"text-dark\">" + attr.info_title + "</h3>" +
					"<div class=\"text-dark\">" + attr.info_text +
					infoButtonString +
					"</div>" +
					"</div>" +
					"</div>";

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			var marker = new google.maps.Marker({
				position: locLatLng,
				map: map,
				icon: icon ? icon : "",
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});

			markers.push(marker);

			marker.addListener("click", function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			// if (offsetHeight && window.innerWidth > 768) {
			//     map.panBy(0, -offsetHeight);
			// }

			bounds.extend(locLatLng);

			if (attr.routes) {
				if (Object.keys(attr.routes).length > 1) {
					if ($("#collapse-location-routes.collapse").length > 0 && $(window).height() > 767) {
						$("#collapse-location-routes.collapse").collapse();
					}

					$("#location-routes .list-group-item-action").on("click", function (e) {
						e.preventDefault();
						$("#location-place-categories").find(".list-group-item-action.active").removeClass("active");
						var elId = $(this).attr("id");
						$.each(attr.routes, function (k, routeAttr) {
							if (elId === routeAttr.title.toLowerCase()) {
								clearMarkers();
								var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);
								calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
							}
						});
					});
				}
			}
		});

		if (settings.places_categories) {
			var placeMarkers = [];

			$("#location-place-categories .list-group-item-action").on("click", function (e) {
				e.preventDefault();
				$("#location-routes").find(".list-group-item-action.active").removeClass("active");

				if ($(this).find(".place-category-icon")) {
					var markerColor = $(this).find(".place-category-icon").css("background-color");
				}

				// Clear directions if any
				directionsDisplay.setMap(null);
				clearMarkers();

				var elId = $(this).attr("id");

				$.each(settings.places_categories, function (title, placesCategory) {
					if (elId === placesCategory.title) {
						$.each(placesCategory.places, function (title, place) {

							var placeMarkerInfowindow = false;
							var placeIcon = {
								// anchor: new google.maps.Point(0, 0),
								strokeColor: markerColor,
								path: "M75.85 68.35L42.5 110 9.15 68.35A41.83 41.83 0 0 1 0 42.21C0 18.94 19.06 0 42.5 0S85 18.93 85 42.2c0 9.87-3.42 18.95-9.15 26.14zM42.5 22.65c-10.55 0-19.13 8.52-19.13 19s8.58 19 19.13 19 19.13-8.52 19.13-19-8.58-19-19.13-19zm0 7.6",
								fillColor: markerColor,
								fillOpacity: 1,
								// scaledSize: new google.maps.Size(1, 1),
								scale: 0.5,
								// strokeWeight: 0,
								// rotation: 0
							};

							if (placesCategory.marker_svg_file) {
								placeIcon = {
									url: placesCategory.marker_svg_file,
									// anchor: new google.maps.Point(0, 0),
									strokeColor: markerColor,
									fillColor: markerColor,
									fillOpacity: 1,
									// scaledSize: new google.maps.Size(8, 8),
									scale: 1,
									// strokeWeight: 0,
									// rotation: 0
								};
							}

							if (place.title || place.description) {
								var placeContentString = "<div>";

								if (place.title) {
									placeContentString = placeContentString + "<h5 class=\"\">" + place.title + "</h5>";
								}
								if (place.description) {
									placeContentString = placeContentString + "<p class=\"mb-0\">" + place.description + "</p>";
								}
								placeContentString = placeContentString + "</div>";

								placeMarkerInfowindow = new google.maps.InfoWindow({
									content: placeContentString
								});
							}

							var placeLocLatLng = new google.maps.LatLng(place.lat, place.lng);

							var placeMarker = new google.maps.Marker({
								position: placeLocLatLng,
								map: map,
								draggable: false,
								icon: placeIcon ? placeIcon : "",
								zIndex: -20,
								infowindow: placeMarkerInfowindow ? placeMarkerInfowindow : false,
							});

							placeMarkers.push(placeMarker);
							bounds.extend(placeLocLatLng);
							map.fitBounds(bounds);
							map.setCenter(bounds.getCenter());
							map.setZoom(map.getZoom()-1);
							map.panTo(bounds.getCenter());
							if (offsetHeight) {
								map.panBy(0, -offsetHeight);
							}
							// if (Object.keys(settings.locations).length > 1) {
							//     map.fitBounds(bounds);
							// }
							// else if (Object.keys(settings.locations).length === 1) {
							//     map.setZoom(settings.zoom-1);
							// }

							placeMarker.addListener("click", function () {
								hideAllPlacesInfoWindows(map, placeMarkers);
								if (this.infowindow) {
									this.infowindow.open(map, this);
								}
								map.setCenter(this.getPosition());
								map.panTo(this.getPosition());

								if (offsetHeight) {
									map.panBy(0, -offsetHeight);
								}
							});
						});
					}
				});
			});
		}

		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}
		else if (Object.keys(settings.locations).length === 1) {
			map.setZoom(settings.zoom);
		}

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
			directionsService.route({
				origin: start,
				destination: end,
				travelMode: "DRIVING"
			}, function(response, status) {
				if (status === "OK") {
					directionsDisplay.setDirections(response);
					directionsDisplay.setMap(map);
					// if (offsetHeight) {
					//     map.panBy(500, +offsetHeight);
					// }
					map.setCenter(this.locLatLng);
				} else {
					window.alert("Directions request failed due to " + status);
				}
			});
		}

		function hideAllPlacesInfoWindows(map, placeMarkers) {
			placeMarkers.forEach(function (placeMarker) {
				if (placeMarker.infowindow) {
					placeMarker.infowindow.close(map, placeMarker);
				}
			});
		}

		// Removes the markers from the map, but keeps them in the array.
		function clearMarkers() {
			setMapOnAll(null);
		}

		// Sets the map on all markers in the array.
		function setMapOnAll(map) {
			for (var i = 0; i < placeMarkers.length; i++) {
				placeMarkers[i].setMap(map);
			}
		}
	};

	/**
	 * Read More Toggler
	 */
	$.fn.readMoreToggler = function() {
		var readMoreToggle = $(this),
			entryContent = $(this).parent().find(".entry-content"),
			readMoreToggleLink = readMoreToggle.find(".read-more-toggle-link"),
			entryContentHeight = entryContent.height(),
			entryContentMaxHeight = readMoreToggleLink.attr("data-max-height");

		if ( entryContentHeight > entryContentMaxHeight ) {
			entryContent.css("max-height", entryContentMaxHeight + "px" ).addClass("faded");
			readMoreToggle.removeClass("d-none");
			readMoreToggleLink.on("click", function(e) {
				e.preventDefault();
				$(this).toggleClass("toggled");
				if ($(this).hasClass("toggled")) {
					$(this).html($(this).attr("data-close-text"));
				}
				else {
					$(this).html($(this).attr("data-open-text"));
				}
				entryContent.toggleClass("toggled");
			});
		}
	};

	/**
	 * Photoswipe Lightbox
	 *
	 * @param options
	 */
	$.fn.photoswipeLightbox = function(options) {
		var el = $(this);

		var settings = $.extend({
			closeOnScroll: true,
			escKey: true,
			arrowKeys: true,
			loop: true,
			history: true,
			focus: true,
			modal: true,
			showHideOpacity: true,
			closeEl: true,
			captionEl: true,
			fullscreenEl: true,
			zoomEl: true,
			shareEl: true,
			counterEl: true,
			arrowEl: true,
			preloaderEl: true,
		}, options);

		el.each( function() {
			var $pic     = $(this),
				getItems = function() {
					var items = [];
					$pic.find("a").each(function() {

						var item = {
							src : $(this).data("src"),
							w   : $(this).data("width"),
							h   : $(this).data("height"),
							msrc   : $(this).find("img").attr("src"),
							title   : $(this).data("title"),
							pid   : $(this).data("slug"),
						};

						items.push(item);
					});
					return items;
				};

			var items = getItems();

			var $pswp = $(".pswp")[0];
			$pic.on("click", "a", function(event) {
				event.preventDefault();

				var $index = $(this).data("index");
				var options = {
					index: $index,
					bgOpacity: 0.7,
					spacing: 0.12,
					allowPanToNext: true,
					pinchToClose: true,
					closeOnScroll: settings.closeOnScroll,
					closeOnVerticalDrag: true,
					escKey: settings.escKey,
					arrowKeys: settings.arrowKeys,
					history: settings.history,
					mouseUsed: false,
					loop: settings.loop,
					focus: settings.focus,
					modal: settings.modal,
					showHideOpacity: settings.showHideOpacity,
					showAnimationDuration: 333,
					hideAnimationDuration: 333,
					closeEl: settings.closeEl,
					captionEl: settings.captionEl,
					fullscreenEl: settings.fullscreenEl,
					zoomEl:  settings.zoomEl,
					shareEl:  settings.shareEl,
					counterEl: settings.counterEl,
					arrowEl: settings.arrowEl,
					preloaderEl:  settings.preloaderEl,
				};

				// Initialize PhotoSwipe
				var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
				lightBox.init();
			});
		});
	};

})(jQuery);
async function WebpIsSupported() {
	// If the browser doesn't has the method createImageBitmap, you can't display webp format
	if (!self.createImageBitmap) return false;

	// Base64 representation of a white point image
	const webpData = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';

	// Retrieve the Image in Blob Format
	const blob = await fetch(webpData).then(r => r.blob());

	// If the createImageBitmap method succeeds, return true, otherwise false
	return createImageBitmap(blob).then(() => true, () => false);
}

function canUseWebP() {
	var elem = document.createElement('canvas');
	if (!!(elem.getContext && elem.getContext('2d'))) {
		// was able or not to get WebP representation
		return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
	}
	// very old browser like IE 8, canvas not supported
	return false;
}

function imageExists(imageUrl){

	var http = new XMLHttpRequest();

	http.open('HEAD', imageUrl, false);
	http.send();

	return http.status != 404;

}

$( document ).ready( function() {
	let bgImageElements = $('*[data-parallax-background-image-url]');
	if (bgImageElements.length > 0) {
		bgImageElements.each(function() {
			let bgImageElement = $(this);
			let bgImageElementUrl = bgImageElement.attr('data-parallax-background-image-url');
			if (bgImageElementUrl) {
				if ( canUseWebP() && imageExists(bgImageElementUrl + '.webp') ) {
					bgImageElement.css('background-image', `url(${bgImageElementUrl}.webp)`);
				} else {
					bgImageElement.css('background-image', `url(${bgImageElementUrl})`);
				}
			}
		});
	}
});
$( document ).ready( function() {
	let body = $('body');
	if ( body ) {
		if ( canUseWebP() ){
			body.addClass ( "webp" );
		}
	}
});
